import React from 'react';
import { Container, Typography } from '@mui/material';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';

export const TesterView = () => {
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}

        >
            <Container maxWidth="sm">
                <Typography variant="h2" gutterBottom>Тест Кейсы и отладка</Typography>
                <TesterViewMenu />
            </Container>
        </HelpingDrawerLayout>
    );
}
